var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 45 29.166 c -0.425 0 -0.853 0.017 -1.285 0.051 c -7.675 0.605 -13.893 6.823 -14.498 14.498 C 28.482 53.04 35.83 60.834 45 60.834 c 0.425 0 0.853 -0.017 1.285 -0.051 c 7.675 -0.605 13.893 -6.824 14.498 -14.499 C 61.518 36.96 54.169 29.166 45 29.166 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.548 0 H 12.452 C 5.575 0 0 5.575 0 12.452 v 65.096 C 0 84.425 5.575 90 12.452 90 h 65.096 C 84.425 90 90 84.425 90 77.548 V 12.452 C 90 5.575 84.425 0 77.548 0 z M 75 50.133 c 0 0.679 -0.55 1.229 -1.229 1.229 h -1.529 c -1.301 0 -2.49 0.802 -2.915 2.032 c -0.341 0.988 -0.741 1.949 -1.196 2.878 c -0.569 1.163 -0.301 2.564 0.615 3.479 l 1.096 1.096 c 0.48 0.48 0.48 1.258 0 1.738 l -7.259 7.259 c -0.24 0.24 -0.554 0.36 -0.869 0.36 s -0.629 -0.12 -0.869 -0.36 l -1.096 -1.096 c -0.591 -0.591 -1.385 -0.912 -2.186 -0.912 c -0.439 0 -0.881 0.096 -1.293 0.298 c -0.929 0.454 -1.89 0.854 -2.878 1.196 c -1.23 0.425 -2.032 1.614 -2.032 2.915 v 1.529 c 0 0.679 -0.55 1.229 -1.229 1.229 H 39.867 c -0.679 0 -1.229 -0.55 -1.229 -1.229 v -1.528 c 0 -1.301 -0.802 -2.49 -2.032 -2.915 c -0.988 -0.341 -1.949 -0.741 -2.878 -1.196 c -0.412 -0.201 -0.854 -0.298 -1.293 -0.298 c -0.801 0 -1.595 0.321 -2.186 0.912 l -1.096 1.096 c -0.24 0.24 -0.554 0.36 -0.869 0.36 s -0.629 -0.12 -0.869 -0.36 l -7.259 -7.259 c -0.48 -0.48 -0.48 -1.258 0 -1.738 l 1.096 -1.096 c 0.916 -0.916 1.183 -2.316 0.615 -3.479 c -0.454 -0.929 -0.854 -1.89 -1.196 -2.878 c -0.425 -1.23 -1.614 -2.032 -2.915 -2.032 h -1.528 c -0.679 0 -1.229 -0.55 -1.229 -1.229 V 39.867 c 0 -0.679 0.55 -1.229 1.229 -1.229 h 1.529 c 1.301 0 2.49 -0.802 2.915 -2.032 c 0.341 -0.988 0.741 -1.949 1.196 -2.878 c 0.569 -1.163 0.301 -2.564 -0.615 -3.479 l -1.096 -1.096 c -0.48 -0.48 -0.48 -1.258 0 -1.738 l 7.259 -7.259 c 0.24 -0.24 0.554 -0.36 0.869 -0.36 s 0.629 0.12 0.869 0.36 l 1.096 1.096 c 0.591 0.591 1.385 0.912 2.186 0.912 c 0.439 0 0.881 -0.096 1.293 -0.298 c 0.929 -0.454 1.89 -0.854 2.878 -1.196 c 1.23 -0.425 2.032 -1.614 2.032 -2.915 v -1.528 c 0 -0.679 0.55 -1.229 1.229 -1.229 h 10.265 c 0.679 0 1.229 0.55 1.229 1.229 v 1.529 c 0 1.301 0.802 2.49 2.032 2.915 c 0.988 0.341 1.949 0.741 2.878 1.196 c 0.412 0.201 0.853 0.298 1.293 0.298 c 0.801 0 1.595 -0.321 2.186 -0.912 l 1.096 -1.096 c 0.24 -0.24 0.555 -0.36 0.869 -0.36 s 0.629 0.12 0.869 0.36 l 7.259 7.258 c 0.48 0.48 0.48 1.258 0 1.738 l -1.096 1.096 c -0.916 0.916 -1.183 2.316 -0.615 3.479 c 0.454 0.929 0.854 1.89 1.196 2.878 c 0.425 1.23 1.613 2.032 2.915 2.032 h 1.529 c 0.679 0 1.229 0.55 1.229 1.229 V 50.133 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.606adb60b69b80998bfead52824fc3ba.svg";
export { ForwardRef as ReactComponent };